import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { animeList } from "@/mocks/anime";

interface Slide {
  id: string;
  tag: string;
  title: string;
  summary: string;
  image: string;
  link: string;
}

const slides: Slide[] = [
  {
    id: "s1",
    tag: "本月焦点",
    title: newsList[0].title,
    summary: newsList[0].summary,
    image: animeList[0].banner,
    link: `/news/${newsList[0].id}`,
  },
  {
    id: "s2",
    tag: "编辑推荐",
    title: `《${animeList[1].title}》：${animeList[1].synopsis}`,
    summary: animeList[1].description[0],
    image: animeList[1].banner,
    link: `/anime/${animeList[1].id}`,
  },
  {
    id: "s3",
    tag: "高分治愈",
    title: `《${animeList[2].title}》：以一千只纸鹤道一场温柔的别`,
    summary: animeList[2].description[0],
    image: animeList[2].banner,
    link: `/anime/${animeList[2].id}`,
  },
  {
    id: "s4",
    tag: "国创热榜",
    title: `《${animeList[3].title}》：水墨美学下的浮空奇谭`,
    summary: animeList[3].description[0],
    image: animeList[3].banner,
    link: `/anime/${animeList[3].id}`,
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((v) => (v + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (idx: number) => setActive((idx + slides.length) % slides.length);

  return (
    <section className="relative w-full h-[380px] md:h-[520px] rounded-lg overflow-hidden bg-foreground-950">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === active ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" />
          <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-10">
            <span className="self-start px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
              {slide.tag}
            </span>
            <h2 className="mt-3 font-heading font-bold text-background-50 text-xl md:text-3xl leading-snug max-w-2xl">
              {slide.title}
            </h2>
            <p className="mt-2.5 text-background-200 text-sm md:text-base leading-relaxed max-w-2xl line-clamp-2">
              {slide.summary}
            </p>
            <Link
              to={slide.link}
              className="mt-4 self-start inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              阅读详情 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => go(active - 1)}
        aria-label="上一张"
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => go(active + 1)}
        aria-label="下一张"
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-5 right-5 md:right-10 flex items-center gap-2">
        {slides.map((slide, idx) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${idx + 1} 张`}
            onClick={() => go(idx)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              idx === active ? "w-7 bg-primary-500" : "w-3 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}